const parse = require('./parse')
const prerelease = (version, options) => {
  const parsed = parse(version, options)
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
}
module.exports = prerelease



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/prerelease.js
// module id = 2456
// module chunks = 0